import React from 'react';
import StaticIcon from '../../../../../components/icon/StaticIcon';
import './statisticall.scss';

const StatisticAll = ({ label, application }) => {
  return (
    <div className="statistic_all">
      <div className="static_info">
        <div className="static_label">{label}</div>
        <div className="static_app">{application}</div>
      </div>
      <div>
        <StaticIcon />
      </div>
    </div>
  );
};

export default StatisticAll;
